/*@flow*/
import type { State } from './types';
import * as I from 'immutable';

const initState = {
  mode: 'NONE',
  portalMode: 'CLOSED',
  resourceName: '',
  mutated: false,
  resource: I.Map(),
};

const mkState: I.RecordFactory<State> = I.Record(initState, 'State');
export default mkState;
